<ng-container *ngTemplateOutlet="isProgram ? programView : productView"></ng-container>

<ng-template #programView>
    <a routerLink="{{ programUrl }}" class="program--card">
        <app-image-container class="font-5" [image]="programImage" type="program"></app-image-container>
        <span class="program--card__label text-align-center mt-2 text-hidden-ellipsis" [innerHTML]="programLabel | safeContent"></span>
    </a>
</ng-template>

<ng-template #productView>
    <div class="product--card">
        <app-product-grid-item [product]="product" [order]="order" [showFeaturedTag]="false" [canCreateOrder]="true" [showOrderSelector]="true"></app-product-grid-item>
    </div>
</ng-template>

